import BottomSheetContent from '../../../components/BottomSheetComponents/BottomSheetContent'
import { openMail } from '../../../utils/appBridge'

const founderEmail = 'prateek.jindal@powerup.money'

type LockDownTimerEndsBottomSheetProps = {
  onDismiss: () => void
}

export function LockDownTimerEndsBottomSheet({ onDismiss }: LockDownTimerEndsBottomSheetProps) {
  return (
    <BottomSheetContent
      onDismiss={onDismiss}
      logoSvg={
        <img
          src='/images/new-elite/powerup-logo.svg'
          alt='powerup-logo'
          className='h-16 w-16 rounded-xl object-contain'
        />
      }
      heading='What happens when access period ends?'
      bottomSheetHeadingClassName='!mb-0 !font-medium !text-[#232323]'
      bottomSheetHeadClassName='!pt-4'
      bottomSheetBodyClassName='!overflow-y-auto no-scrollbar !pt-4 !pb-2'
    >
      <div className='flex flex-col gap-4 text-sm font-normal leading-[1.5] text-[#232323]'>
        <p className='font-medium'>
          Your Elite membership has expired. After the 7-day timer ends, access to PowerUp's research, insights, and premium features will be restricted.
        </p>
        <p>
          You will be able to view your investments, SIP and orders,
          <span className='font-medium'> but an Elite membership is still required to get the full PowerUp experience.</span>
        </p>
        <p>
          PowerUp is built to provide investors with access to high-quality research, actionable insights and tools that help them invest with greater confidence and build long-term wealth.
        </p>
        <p>
          We have intentionally kept Elite at just{' '}
          <span className='line-through'>₹1,999/yr</span> ₹999/yr. to make it accessible to as many investors as
          possible. <span className='font-medium'>This fee enables us to continuously invest in high-quality research &amp; product development to
            deliver the experience our members expect.</span>
        </p>
        <p>
          In case your Elite membership didn&apos;t deliver the value you expected, we&apos;d genuinely appreciate your
          feedback. It will help us make Elite even more useful. You can directly email our founder at:{' '}
          <div
            className='inline cursor-pointer underline text-[#1470CC]'
            onClick={() => openMail(founderEmail)}
          >
            {founderEmail}
          </div>
        </p>
      </div>
    </BottomSheetContent>
  )
}
